import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=18130d9f&"
import script from "./BackButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./BackButton.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports